import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront';
import { UigUserCellComponent } from '../uig-user-cell/uig-user-cell.component';

@Component({
    selector: 'app-uig-status-cell',
    templateUrl: './uig-status-cell.component.html',
    styleUrls: ['./uig-status-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigStatusCellComponent extends UigUserCellComponent {
  constructor(protected outlet: OutletContextData<TableDataOutletContext>) {
    super(outlet)
  }

  get label() {
    if (this.isActive === undefined) {
      return;
    }
    return this.isActive ? 'organization.enabled' : 'organization.disabled';
  }

  get isActive(): boolean {
    return this.model.active;
  }
}
